module.exports = __webpack_public_path__ + "media/applicants/android@2x-3d3e5e9a.png";